// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1AsXd","list":"styles_list__s4dIH"};